<template>
  <div class="layout-wrapper">
    <nav class="sidebar" :class="{'sidebar-collapsed': !sidebarExpanded}">
      <Sidebar
        :sidebarExpanded="sidebarExpanded"
        :on-route-changed="onRouteChanged"
        :logout="logout"
        :user="user" />
    </nav>
    <div class="header main-app-header">
      <div class="header-wrapper">
        <div class="header-content">
          <div class="sidebar-header">
            <router-link class="sidebar-header-logo" to="/">
              <img class="logo-img" src="@/assets/images/logos/BPLogo-01.svg" alt="logo-img">
            </router-link>
            <a class="sidebar-collapse" @click="toggleSidebar">
              <div class="hamburger hamburger--squeeze" :class="{'is-active': sidebarExpanded}">
                <div class="hamburger-box">
                  <div class="hamburger-inner"></div>
                </div>
              </div>
            </a>
          </div>
          <a class="header-link logout-link" @click.prevent="logout">
            <img class="header-link-img" src="@/assets/images/icons/logout.png" alt="logout"/> {{ $t('SIDEBAR.logout')}}</a>
          <router-link :to="{ name: 'Profile' }" class="profile-link" @click.native="logProfileClick" >
            <a class="header-link header-link-transparent" v-if="user">
              <img class="header-link-img" v-if="user.photo === 'https://s3.us-east-2.amazonaws.com/dev-player-photo/default-photo.png' || user.parentId" src="@/assets/images/icons/profile.png" alt="avatar"/>
              <img class="header-link-img profile-image" v-if="user.photo !== 'https://s3.us-east-2.amazonaws.com/dev-player-photo/default-photo.png' && user.photo" :src="user.photo" alt="avatar"/>
              <span class="text-uppercase">{{user.firstName}} {{user.lastName}}</span>
            </a>
          </router-link>
        </div>
        <breadcrumb></breadcrumb>
      </div>
    </div>

    <div class="main-content" :class="{'main-content-full': !sidebarExpanded}">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/common/Breadcrumb'
import { LOGOUT } from '@/store/action.types'
import Sidebar from '@/components/common/Sidebar'
import { mapActions, mapGetters } from 'vuex'
import { SIDEBAR_CALLAPSED } from '@/common/events.types'

export default {
  name: 'AppLayout',
  data () {
    return {
      sidebarExpanded: window.screen.width * window.devicePixelRatio > 1900,
    }
  },
  computed: {
    ...mapGetters(['user'])
  },
  methods: {
    ...mapActions({
      logoutAction: LOGOUT
    }),
    logout () {
      this.logoutAction()
        .then(() => {
          this.$router.push({ name: 'Login' })
        })
    },
    toggleSidebar () {
      const playbookNav = document.getElementById('subnavPlaybook');
      if(playbookNav && playbookNav.classList.contains('show')) {
        this.$root.$emit('bv::toggle::collapse', 'subnavPlaybook');
      }
      this.sidebarExpanded = !this.sidebarExpanded

      setTimeout(() => {
        this.$eventHub.$emit(SIDEBAR_CALLAPSED, { message: this.$t("TOAST_MESSAGES.errorTryAgain") })
      }, 300)
    },
    onRouteChanged () {
      if (window.screen.width * window.devicePixelRatio <= 1900) {
        this.sidebarExpanded = false
      }
    },
    logProfileClick() {
      this.$amplitude.logEvent('pwa: click on navbar link', {link: 'PROFILE'})
    }
  },
  components: {
    Sidebar,
    Breadcrumb,
  }
}
</script>

<style lang="scss">
  @import '@/scss/views/_profile.scss';
</style>
